import { skipToken, useQuery } from '@tanstack/react-query';

import { GET_PENDING_TEAM_INVITATIONS } from '../../contracts/keys';
import { listPendingTeamInvitations } from '../api/teams';
import { getWorkspaceDataConfig } from '../config';

export { GET_PENDING_TEAM_INVITATIONS };

interface UseQueryPendingTeamInvitationsOptions {
  enabled?: boolean;
  /**
   * Read the list again on this mount even when a recent copy is cached, for
   * a decision that must rest on the invitations as they are now.
   */
  fresh?: boolean;
}

/**
 * Invitations the caller can still answer. Distinct from the switcher's
 * `useQueryWorkspaceInvitations`: team-shaped, and ungated by multi-workspace.
 */
export function useQueryPendingTeamInvitations({
  enabled = true,
  fresh = false,
}: UseQueryPendingTeamInvitationsOptions = {}) {
  const token = getWorkspaceDataConfig().useAuthToken();

  return useQuery({
    queryKey: [GET_PENDING_TEAM_INVITATIONS],
    staleTime: fresh ? 0 : 60 * 1000,
    refetchOnMount: fresh ? 'always' : true,
    queryFn:
      token && enabled
        ? async () => {
            const { data } = await listPendingTeamInvitations();
            return data;
          }
        : skipToken,
  });
}
